import CheckboxIconSelection from './CheckboxIconSelection';

export default CheckboxIconSelection;
